// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/store.js" // 引入store
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Print from './plugins/print'

import VueCookies from 'vue-cookies'
import axios from "../api/" // 导入axios 
Vue.prototype.$api = axios // 挂载到原型链上, 在vue组件里面可以通过this拿到

import "./assets/css/index2.css";
//全局注册过滤器 将string 转换为2位数值
Vue.filter('stringToFloat', function(s, f, d) {
    if (s === '' || s == null || typeof s == 'undefined') {
        return ''
    }
    if (f == null || f == '' || typeof f == 'undefined') {
        f = 2;
    }
    if (d == null || d == '' || typeof d == 'undefined') {
        d = 1;
    }
    var num = Number(s)
    if (Number.isNaN(num)) {
        return s
    }

    let ret = (num / d).toFixed(f);
    var strs = ret.split('.')
    if (strs[1] == 0) {
        return strs[0];
    }
    return ret;
})
Vue.filter('dateFormater', function(str) {
    if (str && str != '') {
        let v = str.slice(0, 10);
        return v;
    } else {
        return '';
    }
})

Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.use(Print) //打印
Vue.config.productionTip = false
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js